export const getAllApplicant = () => ({
    url: `admin/applicant`,
    method: 'GET'
})

export const addApplicant = (data) => ({
    url: `admin/applicant`,
    method: 'POST',
    body: { ...data }
})

export const editApplicant = ({ data, id }) => ({
    url: `admin/applicant/${id}`,
    method: 'PUT',
    body: { ...data },
})

export const getSingleApplicant = (id) => ({
    url: `admin/applicant/${id}`,
    method: 'GET'
})

export const deleteApplicant = (id) => ({
    url: `admin/applicant/${id}`,
    method: 'DELETE'
})